__turbopack_context__.v({
  "homeTrust": "home-trust-module-scss-module__e-RwIq__homeTrust",
  "homeTrustBadge": "home-trust-module-scss-module__e-RwIq__homeTrustBadge",
  "homeTrustBadges": "home-trust-module-scss-module__e-RwIq__homeTrustBadges",
});
